import React, { useRef } from "react";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import CompanyPoliciesData from "../../data/company-policies.json";
import CompanyPoliciesContainer from "../../containers/investor-relations/company-policies";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

const CompanyPoliciesPage = () => {
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Company Policies | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Company Policies"
                        excerpt=""
                        image="/images/banner/page/company-policies.png"
                    />
                    <CompanyPoliciesContainer
                        contRef={contRef}
                        data={CompanyPoliciesData}
                    />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default CompanyPoliciesPage;
